import { useCallback } from 'react'
import { useForm as useReactHookForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import omit from 'lodash/fp/omit'
import run from 'lodash/fp/over'
import same from 'lodash/fp/identity'

const useForm = ({ validations = {}, ...settings } = {}) => {
   const form = useReactHookForm({
      resolver: yupResolver(validations),
      ...settings
   })
   const createControlledComponent = Component =>
      useCallback(function ControlledFormField({
         fieldName,
         onChange,
         transform = {},
         ...otherProps
      }) {
         return (
            <Controller
               name={fieldName}
               control={form.control}
               render={({ field, fieldState }) => {
                  const transformInput = transform?.input || same
                  const transformOutput = transform?.output || same
                  const composedOnChangeHanlder = useCallback(
                     run([onChange, v => field.onChange(transformOutput(v))]),
                     []
                  )

                  return (
                     <Component
                        {...omit('ref', field)}
                        value={transformInput(field.value)}
                        {...otherProps}
                        error={fieldState?.error?.message}
                        onChange={composedOnChangeHanlder}
                     />
                  )
               }}
            />
         )
      },
      [])

   return { form, createControlledComponent }
}

export default useForm
